import ApiUtil from './api';

class Api extends ApiUtil {
  constructor() {
    super();

    this.unsubscribe = {
      groupInvitation: (id) => {
        return this.post('/account/group-invite-unsubscribe/' + id);
      },

      contactInvitation: (id) => {
        return this.post('/account/contact-invite-unsubscribe/' + id);
      },

      newsletter: (id) => {
        return this.post('/account/newsletter-unsubscribe/' + id);
      },

      emailNotifications: (id) => {
        return this.post('/account/notifications-unsubscribe/' + id);
      },
    };
  }

  contact(publicId) {
    return this.get(`/public/${publicId}`, null, 'apiCacheRoot');
  }

  postsfeed(publicId) {
    return this.get(`/home/user/${publicId}/postsfeed/public`, null, 'apiCacheRoot');
  }

  group(publicId) {
    return this.get('/group/public/' + publicId);
  }

  groupById(groupId) {
    return this.get('/group/publicById/' + groupId);
  }

  getEvent(publicId) {
    return this.get('/event2/public/' + publicId);
  }

  getEventById(eventId) {
    return this.get('/event2/publicById/' + eventId);
  }

  getPage(publicId) {
    return this.get(`/pages/page/${publicId}/public`);
  }

  getPagePublicPostsFeed(uuid, params) {
    return this.getNextPageOr(`/pages/page/${uuid}/postsfeed`, params, 'apiCacheRoot');
  }

  getPageHashTags(params, pageId) {
    const headers = { data: params };
    return this.get(`/pages/page/${pageId}/hashtags`, headers, 'apiCacheRoot');
  }

  inviteeData(mergeId) {
    return this.post(`/mycontacts/mail-invite-confirm/${mergeId}`);
  }

  getPublicFeed(params) {
    return this.get(`/discover/public-posts-feed`, {
      data: params,
    });
  }
}

export default new Api();
